module.exports = `${require.publicPath}banner-img01.bc518eca.png`;